module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner-header"
  }, [_c('div', [_vm._v("banner管理 / 操作")]), _vm._v(" "), _c('div', [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.isOperation) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(1)
      }
    }
  }, [_vm._v("草稿")]) : _vm._e(), _vm._v(" "), (_vm.isOperation) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(2)
      }
    }
  }, [_vm._v("发布")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "banner-main"
  }, [_c('el-form', {
    ref: "ruleFormRef",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "BANNER名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "banner名称不在app上显示，仅供后台管理参考",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "title", $$v)
      },
      expression: "ruleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.daterange),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "daterange", $$v)
      },
      expression: "ruleForm.daterange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 5,
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.orderNum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "orderNum", $$v)
      },
      expression: "ruleForm.orderNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "位置类型",
      "prop": "positionType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.positionType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionType", $$v)
      },
      expression: "ruleForm.positionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "3.0.0版本之前的发现频道",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跑步记录顶部",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动音乐顶部",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页-为你推荐",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "社区-动态",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本及之后的发现频道",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "问卷调查",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页BANNER",
      "value": 8
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BANNER图",
      "prop": "bannerImage"
    }
  }, [_c('UploadItems', {
    attrs: {
      "urls": _vm.ruleForm.bannerImage,
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=8",
      "readonly": !_vm.isOperation
    },
    on: {
      "onUrls": _vm.onUrls
    }
  }), _vm._v(" "), (_vm.ruleForm.positionType == 1) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸750 * 418，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 2) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸750 * 270，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 3) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸750 * 270，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 4) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸584 * 240，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 5) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸686 * 240，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 6) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸686 * 240，格式为jpg、png\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ruleForm.positionType == 7) ? _c('div', {
    staticClass: "upload__tip"
  }, [_vm._v("\n          建议：尺寸750 * 270，格式为jpg、png\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击资源",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "type", $$v)
      },
      expression: "ruleForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无跳转",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有文章",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有话题",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至URL",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有活动",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至微信小程序",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至音频",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至支付宝小程序",
      "value": 9
    }
  })], 1)], 1), _vm._v(" "), ([1, 2].includes(_vm.ruleForm.type)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.ruleForm.type === 1 ? '文章ID' : '话题ID',
      "prop": "targetId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.targetId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "targetId", $$v)
      },
      expression: "ruleForm.targetId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ([5, 6].includes(_vm.ruleForm.type)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.ruleForm.type === 5 ? 'H5' : '活动链接',
      "prop": "targetUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "targetUrl", $$v)
      },
      expression: "ruleForm.targetUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ruleForm.type === 7 || _vm.ruleForm.type === 9) ? _c('el-form-item', {
    attrs: {
      "label": "小程序原始ID",
      "prop": "miniId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.miniId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "miniId", $$v)
      },
      expression: "ruleForm.miniId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ruleForm.type === 7 || _vm.ruleForm.type === 9) ? _c('el-form-item', {
    attrs: {
      "label": "小程序路径",
      "prop": "miniPath"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.miniPath),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "miniPath", $$v)
      },
      expression: "ruleForm.miniPath"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ruleForm.type === 8) ? [_c('el-form-item', {
    attrs: {
      "label": "专辑ID",
      "prop": "audioID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.audioID),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "audioID", $$v)
      },
      expression: "ruleForm.audioID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主播名称",
      "prop": "audioNickName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.audioNickName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "audioNickName", $$v)
      },
      expression: "ruleForm.audioNickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单曲数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.audioCount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "audioCount", $$v)
      },
      expression: "ruleForm.audioCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否付费"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    attrs: {
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.audioIsPaid),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "audioIsPaid", $$v)
      },
      expression: "ruleForm.audioIsPaid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    on: {
      "change": _vm.bindRadioChange
    },
    model: {
      value: (_vm.ruleForm.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "applicableCampus", $$v)
      },
      expression: "ruleForm.applicableCampus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperation
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperation
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.ruleForm.applicableCampus ? '应用学校' : '屏蔽学校',
      "required": _vm.ruleForm.applicableCampus ? true : false,
      "prop": "rootUnids"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择学校",
      "filterable": "",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.schoolData),
      callback: function($$v) {
        _vm.schoolData = $$v
      },
      expression: "schoolData"
    }
  }, _vm._l((_vm.schoolDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    on: {
      "click": _vm.onAddSchools
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.ruleForm.rootUnids), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "dialog-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.onDelSchools(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n          共计" + _vm._s(_vm.ruleForm.rootUnids.length) + "所学校\n        ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告曝光代码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "adExposingCodes", $$v)
      },
      expression: "ruleForm.adExposingCodes"
    }
  })], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abd3eff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/banner/bannerDetail.vue
// module id = 1113
// module chunks = 0